import { Routes, Route, Navigate } from 'react-router-dom';
import { RandomnessToolPage } from './tools/RandomnessToolPage';

export function ToolsPage() {
  return (
    <Routes>
      <Route index element={<Navigate to="randomness" replace />} />
      <Route path="randomness" element={<RandomnessToolPage />} />
    </Routes>
  );
}
